<template>
  <div id="newblog">
    <div v-if="$store.state.admin">
      <h1>New Post</h1>
      <div id="postform">
        <label>title</label>
        <input id="titleinput" v-model="title" name="titleinput" placeholder="Enter title here...">
        <label>url slug</label>
        <input id="sluginput" v-model="slug" name="sluginput" placeholder="URL slug for post..." v-on:change="validateSlug()" :class="validslug ? '' : 'invalid'">
        <label>featured image</label>
        <input id="featuredimage" v-model="featuredImage" name="imageinput" placeholder="https://lexikitchen.s3.amazonaws.com/lexikitchen/example.png">
        <label>content</label>
        <textarea v-model="content" id="contentinput" name="contentinput" placeholder="Enter body markdown content here..."></textarea>
        <input type="file" name="upload" id="fileinput">
        <button v-on:click="uploadIt()">Upload</button>
      </div>
      <transition name="fade" mode="out-in">
        <div id="previewcontainer" v-if="content">
          <div class="featuredimagecontainer">
            <img :src="featuredImage">
          </div>
          <h2>{{title}}</h2>
          <vue-markdown :source="content" :html='true'></vue-markdown>
        </div>
      </transition>
      <h3>excerpt</h3>
      <textarea id="excerptinput" v-model="excerpt" name="excerpt" placeholder="A short intro that will display in metadata..."></textarea>
      <div class="buttonscontainer">
        <v-select class="statusbutton" v-model="status" :options="['Draft','Published','Hidden']"></v-select>
        <button id="publishbutton" v-on:click="postBlog(title, $store.state.username, content, status, excerpt, slug, featuredImage)">Publish Blog</button>
      </div>
    </div>
  </div>
</template>

<script>
import VueMarkdown from 'vue-markdown'
import vSelect from 'vue-select'
// import AWS from 'aws-sdk'
import auth from '../mixins/auth'
import axios from 'axios'


export default {
  name: 'NewBlog',
  mixins: [auth],
  data() {
    return {
      title: '',
      content: ``,
      author: this.$store.state.username,
      excerpt: '',
      status: 'Draft',
      slug: '',
      featuredImage: '',
      validslug: true,
      editPost: {}
    }
  },
  components: {
    VueMarkdown,
    'v-select': vSelect
  },
  beforeMount() {
    this.$store.commit('setHeaderClass', '');
    if (this.$route.params.id) {
      this.loadPostData(this.$route.params.id);
    }
  },
  methods: {
    async postBlog(title, author, content, status, excerpt, slug, featuredImage) {

      if ( !title || !author || !content || !status) {
        alert("Please fill in all fields.");
        return null
      }

      if (!this.validateSlug()) {
        alert("Please provide a valid url slug.");
        return null
      }

      var created = new Date();

      const postdata = {
        title: title,
        author: author,
        content: content,
        status: status,
        excerpt: excerpt,
        created: created,
        featuredImage: featuredImage,
        slug: slug
      }

      console.log('Post Data:', postdata);

      this.$store.commit('postBlog', postdata)

    },
    validateSlug() {
      const regex = new RegExp('^[a-z0-9]+(?:-[a-z0-9]+)*$');
      this.validslug = regex.test(this.slug)
      return regex.test(this.slug)
    },
    uploadIt() {
      const fileel = document.getElementById("fileinput")
      this.uploadFile(fileel)
    },
    loadPostData(slug) {

      const init = {
        headers: {
          "Content-Type": 'application/json',
          "X-Api-Key": "NhLutvx5gP2646WFTQ8Ds1i8jHqQ0fILaHUZ7hEs",
        }
      }

      const apiurl = 'https://app5oy8hu1.execute-api.us-east-1.amazonaws.com/dev/blog/get'

      axios
        .get(apiurl, init)
        .then( response => {
          console.log(response);
          this.$store.commit('addPostData', response.data)

          for (var i = 0; i < this.$store.state.posts.length; i++) {
            const post = this.$store.state.posts[i];
            if (post.slug.S === slug) {
              this.editPost = post
              this.title = post.title.S
              this.content = post.content.S
              this.author = post.author.S
              this.excerpt = post.excerpt.S
              this.status = post.status.S
              this.slug = post.slug.S
              if (post.featuredImage) {
                this.featuredImage = post.featuredImage.S
              }
              return post
            }
          }

        })
    }
  }
}
</script>

<style scoped lang="scss">

  #newblog {
    max-width: 760px;
    margin: auto;
  }
  #titleinput {
    width: calc(100% - 20px);
    border: 1px solid #eaeaea;
    margin: 10px 0;
    font-size: 30px;
    padding:10px;
    font-family: 'Nanum Myeongjo', 'Open Sans', Helvetica, Arial, sans-serif;
  }

  #contentinput {
    width: calc(100% - 20px);
    padding: 10px;
    border: 1px solid #eaeaea;
    font-size: 16px;
    min-height: 300px;
    margin-bottom: 20px;
  }

  #publishbutton {
    font-size: 20px;
    background-color: var(--amazonOrange);
    color: #ffffff;
    border: 1px solid #eaeaea;
    padding: 10px 26px;
  }

  #excerptinput {
    width: calc(100% - 20px);
    padding: 10px;
    border: 1px solid #eaeaea;
    font-size: 16px;
    min-height: 50px
  }

  #previewcontainer {
    padding:15px;
    background-color: #eaeaea;
  }

  .buttonscontainer {
    text-align: right;

  }

  #sluginput {
    font-size: 16px;
    padding: 10px;
    border: 1px solid #eaeaea;
    width: 250px;
  }

  #featuredimage {
    font-size: 16px;
    padding: 10px;
    border: 1px solid #eaeaea;
    width: calc(100% - 20px);
    max-width: 100%;
  }

  #postform {
    label {
      display: block;
      font-family: 'Nanum Myeongjo', 'Open Sans', Helvetica, Arial, sans-serif;
      font-size: 16px;
      margin-bottom: 7px;
      margin-top: 20px;
    }
    input {
      display: block;
    }
  }

  .featuredimagecontainer {
    text-align: center;
    img {
      max-width: 100%;
    }
  }

</style>

<style lang="scss">
  button.clear {
    display: none;
  }

  .statusbutton {

    .dropdown-toggle {
      max-width: 160px;
      text-align: right;
      margin: 25px 0 20px auto;
    }

    ul.dropdown-menu {
      max-width: 160px;
      margin: 0 0 0 auto;
      right: 0;
      left: auto;
    }
  }

  input.invalid {
    border: 1px solid red!important;
  }

</style>
